import { Injectable } from '@angular/core'
import { App, AlertController } from 'ionic-angular'
import { Storage } from '@ionic/storage'
import { Observable } from 'rxjs'
import 'rxjs/add/operator/do'
import 'rxjs/add/operator/distinctUntilChanged'
import { Store } from '@ngrx/store'

import { JwtHelperService } from '@auth0/angular-jwt'

import { AuthApi, ICredential, ILoginResponse } from '../apis'

import { AppState } from '../reducers'
import { Authorized, Unauthorized } from '../actions/auth'

@Injectable()
export class AuthService {
  constructor(
    private api: AuthApi,
    private app: App,
    private storage: Storage,
    private store: Store<AppState>,
    private alertCtrl: AlertController,
    private jwtHelper: JwtHelperService,
  ) {
    // 認証切れ検知
    store.select((state) => state.auth.authorized)
      .distinctUntilChanged() // 同じ値が重複したときに1つだけ発行するようにする
      .subscribe((authorized) => {
        if (authorized === false) {
          // 401が返ってきたとき
          this.clearToken()
          this.showSessionExpiredAlert()
        }
      })
  }

  public authenticated(token) {
    return token && !this.jwtHelper.isTokenExpired(token)
  }

  public login(auth: ICredential): Observable<ILoginResponse> {
    return this.api.login(auth)
                   .do((r) => {
                     this.setToken(r.jwt)
                     this.authorized()
                   })
  }

  public logout() {
    this.clearToken()
  }

  public getToken(): Promise<string> {
    return this.storage.ready()
      .then(() => this.storage.get('token'))
  }

  public setToken(token: string) {
    this.storage.ready()
      .then(() => this.storage.set('token', token))
  }

  public clearToken() {
    this.storage.ready()
      .then(() => this.storage.remove('token'))
  }

  public authorized() {
    this.store.dispatch(new Authorized())
  }

  public unauthorized() {
    this.store.dispatch(new Unauthorized())
  }

  private showSessionExpiredAlert() {
    let alert = this.alertCtrl.create({
      title: 'セッションの有効期限切れ',
      message: 'セッションの有効期限が切れたため、再ログインが必要です。',
      buttons: [{
        text: 'OK',
        handler: () => {
          alert.dismiss().then(() => {
            // ログイン画面に遷移
            this.app.getRootNav().setRoot('LoginPage', {}, { animate: true })
          })
          return false
        }
      }],
    })
    alert.present()
  }
}



// WEBPACK FOOTER //
// ./src/services/auth.ts